import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBoxLayout } from './subcomponents';
const MessageBoxContainer = ({ children }) => {
    return (_jsx(MessageBoxLayout, { top: "large", "data-cy": "message-box-container", children: children }));
};
export default MessageBoxContainer;
